import { Subscription } from 'rxjs';
import { MenuService } from '@services/menu.service';
import { SideMenuStateService } from '@services/side-menu-state.service';
import { IMenusModel } from '@models/AppMenus';
import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
	selector: 'side-menu-content',
	templateUrl: './content.component.html',
	styleUrls: ['./content.component.scss'],
})
export class SideMenuContentComponent implements OnInit, OnDestroy {

	public appPages: IMenusModel[];

	public Collapsed: boolean = false;

	private subs: Subscription[] = [];

	constructor(private MenuService: MenuService,
		private SideMenuStateService: SideMenuStateService) { }

	async ngOnInit() {

		const subMenus = this.MenuService.Menus.subscribe((menus:IMenusModel[]) => {

			this.appPages = menus;
		});

		const subCollapsed = this.SideMenuStateService.Collapsed.subscribe(collapsed => this.Collapsed = collapsed);

		this.subs.push(subMenus, subCollapsed);
	}

	ngOnDestroy(): void {
		this.subs.forEach(sub => sub.unsubscribe());
	}


	public OnSetModules(menu:IMenusModel)
	{
		// this.MenuService.SetMenuSelected(menu);
	}

}
